import { POST_WITH_ID } from '@brickwise/asset-validation';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageViewList } from 'src/components/ui/ImageViewList';
import { UploadDropzone } from 'src/components/ui/UploadDropzone';

interface Props {
  disabled?: boolean;
}

export const FloorplanImageSelector: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  const formik = useFormikContext<POST_WITH_ID>();

  const currentImages = formik.values.images?.floorPlans || [];

  return (
    <div>
      <label>{t('dashboard.assets.addedit.main.floorplandescription.upload.label')}</label>
      <UploadDropzone
        fieldname="floorPlans-field"
        disabled={disabled}
        imageUploaded={(url: string, name: string) => {
          formik.setFieldValue('images.floorPlans', [
            ...currentImages,
            {
              src: url,
              name,
            },
          ]);
        }}
      />
      <ImageViewList disabled={disabled} data={currentImages} setData={(data) => formik.setFieldValue('floorPlans', data)} />
    </div>
  );
};
